import 'core-js/fn/array/find'
import 'core-js/fn/array/includes'
import 'core-js/fn/number/is-nan'
import 'core-js/fn/array/find-index'
import 'core-js/fn/array/from'
import 'core-js/fn/set'



// WEBPACK FOOTER //
// ./src/utils/polyfills.js